import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useDayRentalPeriodicHikeDaySubmit from "hooks/useDayRentalPeriodicHikeDaySubmit";
import DynamicAirportPeriodicHikeDayInput from "components/form/DynamicAirportPeriodicHikeDayInput";

import InputAreaDate from "components/form/InputAreaDate";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import SelectStateCity from "components/form/SelectStateCity";
// import DateRangePicker from "components/form/InputDateRangePicker";

const DayRentalPeriodicHikeDayDrawer = ({ id }) => {
  const {
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    selectedCity,
    onSubmit,
    handleCityChange,
    trigger,
    errors,
    startDate,
    endDate,
    setEndDate,
    handleStartDateChange,
    loading,
  } = useDayRentalPeriodicHikeDaySubmit(id);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Day Rental Periodic Hike Day"} description={""} />
        ) : (
          <Title title={"Add Day Rental Periodic Hike Day"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-2 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-12 gap-6 mb-6">
              <div className="col-span-12">
                <LabelArea label={"Select State and City"} />
                <SelectStateCity
                  onSelectState={handleCityChange}
                  register={register}
                  required={false}
                  name="state"
                  selectedServiceState={selectedCity}
                  setSelectedServiceState={handleCityChange}
                />

                <Error errorName={errors.state} />
              </div>

              <div className="col-span-6">
                <LabelArea label="Start Date" />
                <InputAreaDate
                  trigger={trigger}
                  register={register}
                  label="Start Date"
                  name="start_date"
                  type="date"
                  value={startDate}
                  onChange={handleStartDateChange}
                  min={new Date()}
                />
                <Error errorName={errors.start_date} />
              </div>
              <div className="col-span-6">
                <LabelArea label="End Date" />
                <InputAreaDate
                  trigger={trigger}
                  register={register}
                  label="End Date"
                  name="end_date"
                  type="date"
                  value={endDate}
                  placeholder="dd/mm/yyyy"
                  onChange={(event) => setEndDate(event)}
                  min={
                    startDate
                      ? startDate < new Date()
                        ? new Date()
                        : startDate
                      : new Date()
                  }
                />
                <Error errorName={errors.end_date} />
              </div>
            </div>

            <DynamicAirportPeriodicHikeDayInput
              register={register}
              trigger={trigger}
              errors={errors}
              dataInput={dataInput}
              setDataInput={setDataInput}
              handleChange={handleChangeInput}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              handleVehicleCategoryChange={handleVehicleCategoryChange}
            />
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default DayRentalPeriodicHikeDayDrawer;
